import ChatAPI from "./chatApi";

export default ChatAPI;
